import { atom } from "jotai";

export const isInstructionSplashScreenOpenAtom = atom(true);
